import React from 'react'
import ConfirmationModal, { ModalDescription } from './ConfirmationModal'

interface RemoveIntegrationModalProps {
  isOpen: boolean
  onOk: () => void
  onCancel: () => void
}

const RemoveIntegrationModal = ({
  onCancel,
  onOk,
  isOpen
}: RemoveIntegrationModalProps) => {
  return (
    <ConfirmationModal
      title='Disconnect Lightspeed'
      confirmLabel='Disconnect'
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
    >
      <ModalDescription>
        This will sign you out of your Lightspeed account and stop all data
        syncing. Connected stores will lose their location and menu assignments,
        and any menus imported from Lightspeed will no longer receive updates.
      </ModalDescription>

      <ModalDescription>
        To resume syncing, you'll need to sign back in and reconnect your
        stores.
      </ModalDescription>
    </ConfirmationModal>
  )
}

export default RemoveIntegrationModal
